// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__a3itq","info":"PatientInfo_info__6o2tj"};